import { downloadFile, getJson, postJson } from "core/utils/http";
import { BancoRespuesta, DatosComprobante, DatosDomiciliacion, DatosPayworks, DatosReferencia, PagoDomiciliadoRespuesta, PagoPendienteRespuesta, PagoRealizadoRespuesta, RespuestaPayworks, SolicitudDomiciliacion } from "../types/pagos.types";

type obtenerBancosHandler = () => Promise<BancoRespuesta[]>;

type domiciliarPagoHandler = (solicitud: SolicitudDomiciliacion) => Promise<DatosDomiciliacion>;

type descargarDomiciliacionHandler = (numeroReferencia: string) => Promise<void>;

type buscarPagosPendientesHandler = () => Promise<PagoPendienteRespuesta[]>;

type buscarPagosRealizadosHandler = () => Promise<PagoRealizadoRespuesta[]>;

type buscarPagosDomiciliadosHandler = () => Promise<PagoDomiciliadoRespuesta[]>;

type obtenerComprobanteHandler = (identificadorPago: string) => Promise<DatosComprobante | undefined>;

type descargarComprobanteHandler = (identificadorPago: string) => Promise<void>;

type descargarComprobantePayworksHandler = (numeroReferencia: string) => Promise<void>;

type generarReferenciaHandler = (pagos: string[], tipo: number) => Promise<DatosReferencia>;

type validarReferenciaHandler = (pagos: string[], tipo: number) => Promise<boolean>;

type obtenerReferenciaHandler = (numeroReferencia: string) => Promise<DatosReferencia | undefined>;

type descargarReferenciaHandler = (numeroReferencia: string) => Promise<void>;

type obtenerUrlECheckHandler = (pagos: string[]) => Promise<string>;

type registrarPagoECheckHandler = (token: string) => Promise<DatosComprobante | undefined>;

type obtenerTokenLigaPagosHandler = (pagos: string[]) => Promise<string>;

type registrarPagoLigaPagosHandler = (token: string) => Promise<DatosComprobante | undefined>;

type obtenerDatosPayworksHandler = (pagos: string[]) => Promise<DatosPayworks>;

type registrarPagoPayworksHandler = (respuesta: RespuestaPayworks) => Promise<DatosComprobante | undefined>;

type obtenerFormasPagoHandler = () => Promise<string[]>;

export const obtenerBancos: obtenerBancosHandler = () =>
	getJson("/Bancos");

export const domiciliarPago: domiciliarPagoHandler = (solicitud: SolicitudDomiciliacion) =>
	postJson("/Pagos/Domiciliacion", solicitud);

export const descargarDomiciliacion: descargarDomiciliacionHandler = (numeroReferencia: string) =>
	downloadFile(`/Pagos/Domiciliacion/${numeroReferencia}`, "Domiciliacion.pdf", null, "application/pdf");

export const buscarPagosPendientes: buscarPagosPendientesHandler = () =>
	getJson("/Pagos/Pendientes");

export const buscarPagosRealizados: buscarPagosRealizadosHandler = () =>
	getJson("/Pagos/Realizados");

export const buscarPagosDomiciliados: buscarPagosDomiciliadosHandler = () =>
	getJson("/Pagos/Domiciliados");

export const obtenerComprobante: obtenerComprobanteHandler = (identificadorPago: string) =>
	getJson(`/Pagos/Comprobante/${identificadorPago}`);

export const descargarComprobante: descargarComprobanteHandler = (identificadorPago: string) =>
	downloadFile(`/Pagos/Comprobante/${identificadorPago}`, "Comprobante.pdf", null, "application/pdf");

export const descargarComprobantePayworks: descargarComprobantePayworksHandler = (numeroReferencia: string) =>
	downloadFile(`/Pagos/Payworks/Comprobante/${numeroReferencia}`, "Comprobante.pdf", null, "application/pdf");

export const generarReferencia: generarReferenciaHandler = (pagos: string[], tipo: number) =>
	postJson("/Pagos/Referencia", { pagos, formaPago: tipo });

export const validarReferencia: validarReferenciaHandler = (pagos: string[], tipo: number) =>
	postJson("/Pagos/Referencia:validar", { pagos, formaPago: tipo });

export const obtenerReferencia: obtenerReferenciaHandler = (numeroReferencia: string) =>
	getJson(`/Pagos/Referencia/${numeroReferencia}`);

export const descargarReferencia: descargarReferenciaHandler = (numeroReferencia: string) =>
	downloadFile(`/Pagos/Referencia/${numeroReferencia}`, "Referencia.pdf", null, "application/pdf");

export const obtenerUrlECheck: obtenerUrlECheckHandler = (pagos: string[]) =>
	postJson("/Pagos/Cheque/Url", { pagos });

export const registrarPagoECheck: registrarPagoECheckHandler = (token: string) =>
	postJson("/Pagos/Cheque", `"${token}"`);

export const obtenerTokenLigaPagos: obtenerTokenLigaPagosHandler = (pagos: string[]) =>
	postJson("/Pagos/LigaPagos/Token", { pagos });

export const registrarPagoLigaPagos: registrarPagoLigaPagosHandler = (token: string) =>
	postJson("/Pagos/LigaPagos", `"${token}"`);

export const obtenerDatosPayworks: obtenerDatosPayworksHandler = (pagos: string[]) =>
	postJson("/Pagos/Payworks/Datos", { pagos });

export const registrarPagoPayworks: registrarPagoPayworksHandler = (respuesta: RespuestaPayworks) =>
	postJson("/Pagos/Payworks", respuesta);

export const obtenerFormasPago: obtenerFormasPagoHandler = () =>
	getJson<any[]>("/Pagos/FormasPago")
		.then(resultado => resultado.map(String));